/**
 * `not-found` as the two client SDKs spell it: RNFirebase prefixes the service, the web SDK does not.
 *
 * A leaf module on purpose (no imports): the write-claim guard (`writeClaims.ts`, ATL-2004) needs this
 * predicate on every guarded commit, and `missingProductDocuments.ts` pulls in the app's atom graph.
 */
export const isFirestoreNotFound = (error: unknown): boolean => {
  const code = (error as { code?: unknown } | null | undefined)?.code
  return code === 'firestore/not-found' || code === 'not-found'
}
